import l from '../../../../../../lang';
import { ReactComponent as CheckCircleIcon } from '../../../../../../assets/icons/check-circle.svg';
import { ReactComponent as FileAltIcon } from '../../../../../../assets/icons/file-alt.svg';
import { ReactComponent as UserCheckIcon } from '../../../../../../assets/icons/user-check.svg';
import { ReactComponent as InfoIcon } from '../../../../../../assets/icons/info-unfilled.svg';
import './styles.scss';

const REQUIREMENTS = [
  {
    key: 'completed',
    Icon: CheckCircleIcon,
  },
  {
    key: 'policies',
    Icon: FileAltIcon,
  },
  {
    key: 'identity',
    Icon: UserCheckIcon,
  },
] as const;

const WebsiteRequirements = () => (
  <div className="website-requirements">
    <p className="website-requirements__title">{l('companyInformation.kyc.website.requirements.title')}</p>
    <ul className="website-requirements__list">
      {REQUIREMENTS.map(({ key, Icon }) => (
        <li key={key} className="website-requirements__item">
          <Icon className="website-requirements__icon" aria-hidden />
          <p className="website-requirements__text">
            <strong>{l(`companyInformation.kyc.website.requirements.${key}.title`)}</strong>{' '}
            {l(`companyInformation.kyc.website.requirements.${key}.description`)}
          </p>
        </li>
      ))}
    </ul>
    <div className="website-requirements__alert">
      <InfoIcon className="website-requirements__alert-icon" aria-hidden />
      <p className="website-requirements__alert-text">
        {l('companyInformation.kyc.website.requirements.socialNetwork')}
      </p>
    </div>
  </div>
);

export default WebsiteRequirements;
